exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "advertisement-list .ui-datagrid .ui-datagrid-header {\n  text-align: left;\n  padding: 0px; }\n\nadvertisement-list .action-panel {\n  float: right;\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/advertisement-list/advertisement-list.component.scss
// module id = ../../../../../src/app/component-module/advertisement-list/advertisement-list.component.scss
// module chunks = main